import '../../theme/text.css';

import { FC, HTMLAttributes } from 'react';

export type TextVariant =
  | 'body-1'
  | 'body-2'
  | 'body-3'
  | 'body-4'
  | 'body-5'
  | 'body-6'
  | 'body-7'
  | 'sub-h1'
  | 'sub-h2'
  | 'sub-h3'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'page-header';

export type ColorVariant =
  | 'teal-2'
  | 'teal-4'
  | 'teal-5'
  | 'green-1'
  | 'green-2'
  | 'green-4'
  | 'green-5'
  | 'green-6'
  | 'soft-green-2'
  | 'soft-green-4'
  | 'soft-green5'
  | 'yellow-2'
  | 'yellow-4'
  | 'yellow-5'
  | 'orange-2'
  | 'orange-4'
  | 'orange-5'
  | 'red-2'
  | 'red-4'
  | 'red-5'
  | 'purple-2'
  | 'purple-4'
  | 'purple-5'
  | 'blue-2'
  | 'blue-4'
  | 'blue-5'
  | 'white'
  | 'neutral-gray-1'
  | 'neutral-gray-2'
  | 'neutral-gray-3'
  | 'neutral-gray-4'
  | 'neutral-gray-5'
  | 'neutral-gray-6'
  | 'error'
  | 'select-highlight-color'
  | 'select-active-color';

export interface Props extends Omit<HTMLAttributes<HTMLSpanElement>, 'color'> {
  variant?: TextVariant;
  color?: ColorVariant;
  bold?: boolean;
  block?: boolean;
}

export const Text: FC<Props> = ({
  variant = 'body-5',
  color = 'neutral-gray-6',
  bold,
  block,
  className,
  children,
  style,
  ...rest
}) => {
  const newClassName = [variant, bold ? 'bold' : '', block ? 'block' : '', className, color ? `color-${color}` : '']
    .filter((c) => Boolean(c))
    .join(' ');

  return (
    <span className={newClassName} color={color} {...rest}>
      {children}
    </span>
  );
};
